import { render, staticRenderFns } from "./SustainableObjectivesList.vue?vue&type=template&id=b87b4100"
import script from "./SustainableObjectivesList.vue?vue&type=script&lang=ts"
export * from "./SustainableObjectivesList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./SustainableObjectivesList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxFormInputQuestion: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/form-input/Question.vue').default,IxTextarea: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/Textarea.vue').default,IxSurveyQuestionGroup: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/survey/QuestionGroup.vue').default,IxButtonPrimary: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/button/Primary.vue').default,IxButtonOutlined: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/button/Outlined.vue').default,IxButtonSecondary: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/button/Secondary.vue').default,IxDialog: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/Dialog.vue').default,IxButtonAction: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/button/Action.vue').default})
